<template>
  <div class="main-content">
    <h2 class="large">{{myTopCategory.name}}</h2>
    <ul class="list_class">
      <li>
        <label class="list_class__title is-open">{{myTopCategory.name}}</label>
        <div class="list_class__body">
          <a href=""><img :src="getCategoryImage(myTopCategory.id)" :alt="myTopCategory.name" @error="onImageError"></a>
          <ul>
          <div v-for="child in myTopCategory.child" v-bind:key="child.id">
            <li>
              <router-link :to="{name: 'list', params: {Id: child.id}}">{{child.name}}</router-link>
            </li>
          </div>
          </ul>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    data: function () {
      return {
        categoryImages: [],
        sortCategories: [],
        myTopCategory: [
          {
            'id': null,
            'name': null,
            'image': '',
            'child': [
              {
                'id': null,
                'name': null,
                'child': []
              }
            ]
          }
        ],
        categoryImage: {},
        kenki_image_path: process.env.VUE_APP_KENKI_IMAGE_PATH,
        noImage: process.env.BASE_URL + '_img/noimage.png'
      }
    },
    // props: ['categorySet', 'Spec'],
    props: {
      categorySet: {
        type: Array,
        require: true
      }
    },
    mounted () {
      this.sortCategories = this.categorySet
      this.setMyTopCategory()
      this.getImagePath(this.myTopCategory.id, this.myTopCategory.child[0].id)
      this.syncPageContext()
    },
    methods: {
      kenkiImagePath: function (product_code,n) {
        return this.kenki_image_path + product_code + '-' + ('00' + (n+1)).slice(-2) + '.jpg'
      },
      getCategoryImage: function (categoryId) {
        return this.categoryImage[categoryId] || this.noImage
      },
      onImageError: function (event) {
        event.target.onerror = null
        event.target.src = this.noImage
      },
      setMyTopCategory: function (){
        var target = {}
        var targetItems = []
        var specName = this.$route.params.Spec
        targetItems = this.sortCategories.filter(function(item){
          if((item.name).indexOf(specName)>=0) return true
        })
        target = targetItems[0]
        this.myTopCategory = target       
      },
      syncPageContext: function () {
        var title = this.myTopCategory && this.myTopCategory.name ? this.myTopCategory.name : this.$route.params.Spec
        var app = this.$root || this.$parent
        if (app) {
          app.category_id = this.myTopCategory ? this.myTopCategory.id : null
          app.active_page_title = title
          if (app.setPageMeta) {
            app.setPageMeta(title)
          }
        }
      },
      getImagePath: function (category_id, id) {
        var myId = id
        var url = process.env.VUE_APP_URL + '/stock_products/search'
        var myToken = process.env.VUE_APP_TOKEN
        var myComId = process.env.VUE_APP_COMPANY_ID
        var param = {}
        param = {
          'limit': 100,
          'stock_product': {
              'category_id': myId,
              'company_id': myComId
          }
        }
        fetch(url, {
          method: "POST",
          mode: "cors",
          headers:  {
            'Content-Type': 'application/json',
             'Authorization': `Token ${myToken}`
          },
          body: JSON.stringify(param)
        })
        .then(res => {
          return res.json()
        })
        .then(data => {
          if (data && data[0] && data[0].product && data[0].product.product_code) {
            this.$set(this.categoryImage, category_id, this.kenkiImagePath(data[0].product.product_code,0))
          } else {
            this.$set(this.categoryImage, category_id, this.noImage)
          }
        })
        .catch(e => {
          console.error(e)
          this.$set(this.categoryImage, category_id, this.noImage)
        })
      },
    },
    watch: {
      categorySet(newSet){
        this.sortCategories = newSet
        this.setMyTopCategory()
        this.getImagePath(this.myTopCategory.id, this.myTopCategory.child[0].id)
        this.syncPageContext()
      }
    }
    
  }
</script>
